import { render } from "./MTokenAddToCart.vue?vue&type=template&id=a00198c6&scoped=true&ts=true"
import script from "./MTokenAddToCart.vue?vue&type=script&lang=ts"
export * from "./MTokenAddToCart.vue?vue&type=script&lang=ts"

import "./MTokenAddToCart.vue?vue&type=style&index=0&id=a00198c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00198c6"]])

export default __exports__